<template>
  <div class="food-counter-component d-flex align-center justify-space-between">
    <div class="d-flex align-center justify-space-between">
      <div class="counter-section d-flex align-center">
        <v-btn
          v-if="item.quantity > 1"
          class="button-count"
          dark
          depressed
          :disabled="disableRemoveItem"
          @click="decrease"
        >
          <font-awesome-icon icon="minus" />
        </v-btn>
        <v-btn
          v-if="item.quantity <= 1"
          class="button-count button-delete"
          dark
          depressed
          :disabled="disableRemoveItem"
          @click="deleteItem"
        >
          <font-awesome-icon icon="times" />
        </v-btn>
        <span class="count font-weight-medium">{{ quantity }}</span>
        <v-btn
          class="button-count"
          dark
          depressed
          @click="increase"
        >
          <font-awesome-icon icon="plus" />
        </v-btn>
      </div>
      <v-badge
        :value="item.comment"
        left
        color="info"
        dot
      >
        <div class="food-name-section">
          <span v-if="false" class="food-type">суши</span>
          <span class="food-name font-weight-regular">{{
            item.menuItem.name
          }}</span>
          <span
            v-if="item.modificationMenuItem"
            class="food-mod"
          >мод: {{ item.modificationMenuItem.modification.name }}</span>
        </div>
      </v-badge>
    </div>

    <div class="price-section">
      <span class="font-weight-medium">{{
        getPrice | amountWithCurrency
      }}</span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'FoodCounter',
    mixins: [mixinSnackbarMessage],
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        showSnackbar: false,
        quantity: 0,
        timeout: null,
        errorMessage: '',
      }
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
      }),
      getPrice () {
        return this.item.price || 0
      },
      disableRemoveItem () {
        return this.item?.disableSubtract
      // return (this.item.free && this.getPrice === 0) || (this.item?.serviceFee && this.item?.quantity === 1)
      },
    },
    watch: {
      'item.quantity' () {
        this.quantity = this.item.quantity
      },
    },
    mounted () {
      this.quantity = this.item.quantity
    },
    methods: {
      increase () {
        this.quantity++
        this.updateItemQuantity()
      },
      decrease () {
        if (this.quantity > 1) {
          this.quantity--
          this.deleteItem()
        }
      },
      deleteItem () {
        this.$store
          .dispatch('baskets/deleteBasketItem', {
            id: this.item.id,
          })
          .then((res) => {
            if (res.status === 200) {
              this.$store
                .dispatch('baskets/fetchSingleBasket', this.basket.id)
                .then(() => {
                  this.quantity = this.item.quantity
                })
            } else {
              this.quantity = this.item.quantity
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      updateItemQuantity () {
        const payload = {
          menuItemId: this.item.menuItem.id,
        }

        if (this.item.modificationMenuItem) {
          payload.modificationId = this.item.modificationMenuItem.id
        }
        if (this.item.comment) {
          payload.comment = this.item.comment
        }

        this.$store
          .dispatch('baskets/addBasketItem', {
            data: payload,
            id: this.basket.id,
          })
          .then((res) => {
            if (res.status === 200) {
              this.quantity = this.item.quantity
              this.$store.commit('baskets/setBasket', res.data.data)
            } else {
              this.quantity = this.item.quantity
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
    },
  }
</script>

<style lang="less" scoped>
.food-counter-component {
  padding-right: 10px;
  padding-left: 5px;
  margin-bottom: 1.43em;
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .counter-section {
    margin-right: 20px;

    .count {
      display: inline-block;
      font-size: 1.78em;
      line-height: 1;
      margin: 0 12px;
    }

    .button-count {
      font-size: 1em;
      background-color: @color-secondary !important;
      min-width: 3.57em !important;
      width: 3.57em !important;
      height: 3.57em !important;
      padding: 0 !important;
      box-shadow: 0 3px 6px #00000029 !important;
      border-radius: 10px;

      &:disabled {
        box-shadow: 0 1px 4px #00000029 !important;
        opacity: 0.7;
        svg {
          opacity: 0.5;
        }
      }

      &.button-delete {
        svg {
          .fill-svg(#FF0034);
        }
      }

      svg {
        width: 1.35em;
        height: 1.35em;
        .fill-svg(@color-primary);
      }
    }
  }

  .food-name-section {
    margin-right: 5px;
    .food-type {
      display: block;
      color: #7b7b7b;
      font-size: 12px;
      line-height: 21px;
    }

    .food-name {
      display: block;
      font-size: 1.43em;
      line-height: 1;
    }

    .food-mod {
      font-size: 14px;
      line-height: 21px;
    }
  }

  .price-section {
    flex-shrink: 0;
    margin-left: 10px;
    span {
      font-size: 1.5em;
      line-height: 1.2;
    }
  }
}
</style>
